// extracted by mini-css-extract-plugin
module.exports = {"detailStyle":"_1jQxMCtiSBzR4Ji065NNfY"};